import React, { useState } from "react";
import { Button, Modal, Alert } from "@toddle-edu/ds-web";
import { connect } from "react-redux";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { handleArchiveChannel } from "MessagingV2/modules/MessagingModule";
import { useI18n } from "Hooks";
import classNames from "classnames";
import classes from "./ChannelArchiveModal.scss";
import {
  CHAT_TYPE_ENUM,
  MESSAGING_ACTIONS,
  MESSAGING_ACTIONS_FROM,
  recordChatActions,
  isMessagingRevempEnabled,
} from "Platform/routes/MessagingV2/modules/Utils";

const ChannelArchiveModal = props => {
  const { chatId, onCloseModal, channelLabel, handleArchiveChannel } = props;

  const { t } = useI18n(["common", "unitPlan"]);

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const onConfirm = async () => {
    setIsButtonDisabled(true);
    handleArchiveChannel({ isArchived: true, chatId });
    setIsButtonDisabled(false);
    recordChatActions({
      action: MESSAGING_ACTIONS.ARCHIVE,
      chatId,
      from: MESSAGING_ACTIONS_FROM.CHAT_ACTIONS,
      chatType: CHAT_TYPE_ENUM.CHANNEL_CUSTOM,
    });
    onCloseModal();
  };

  const isUIRevempEnabled = isMessagingRevempEnabled();

  return (
    <Modal
      height="354px"
      hasOverlay={true}
      width="530px"
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onClose={onCloseModal}
      isOpen={true}
      footerSeparator={true}
    >
      <Modal.Header
        title={t("common:archive_label_que", {
          label: channelLabel,
        })}
        isClosable={true}
        hasSeparator={isUIRevempEnabled}
      />

      <Modal.Body isScrollable={true}>
        <div className={classNames(classes.modalSubHeading, "text-body-1")}>
          {t("common:this_channel_will_be_archived_msg")}
        </div>
        <div className={classes.alertContainer}>
          <Alert
            type={"info"}
            showIcon={true}
            title={t("common:search_channel_content_unarchive_channel_msg")}
          />
        </div>
      </Modal.Body>
      <Modal.Footer hasSeparator={isUIRevempEnabled ? true : false}>
        <div className={classes.footerContainer}>
          <Button variant="outlined-subtle" size="large" onClick={onCloseModal}>
            {t("common:cancel")}
          </Button>
          <Button
            variant="primary"
            size="large"
            onClick={onConfirm}
            disabled={isButtonDisabled}
          >
            {t("common:archive_label", { label: t("common:channel") })}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

const mapActionCreators = { handleArchiveChannel, setToastMsg };

export default connect(null, mapActionCreators)(ChannelArchiveModal);
